// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2162": "50116afa419c","5856": "0308423753f6","6863": "454c9f289029","8357": "dd422574e14d","8717": "645e3c4e38a1",}[chunkId] + ".css"
}